import { ApiGraphqlTypes as AGT } from '@nizza/core';
import { GraphQLClient } from 'graphql-request';
import env from '~env';
import { HighlightProductProvider, HighlightProduct } from '../../domain';

const API_URL = env.apiUrls.graphql;
export class GraphqlHighlightProductProvider
  implements HighlightProductProvider
{
  private client: GraphQLClient;

  constructor() {
    this.client = new GraphQLClient(API_URL);
  }

  async highlightProduct(data: HighlightProduct): Promise<void> {
    const { highlightProduct } = await this.client.request(
      AGT.HighlightProductDocument,
      {
        data: {
          account: data.account,
          idEvent: data.idEvent,
          collection: data.collectionId,
          productIds: data.productIds,
          showProduct: data.showProduct,
        },
      },
    );

    this.propagateGraphqlErrorIfExists(
      highlightProduct as AGT.HighlightProductResult,
    );
  }

  private propagateGraphqlErrorIfExists(res: AGT.HighlightProductResult) {
    if (res.message === 'ErrorGeneral') throw new Error();
  }
}
